<template>
    <div class="inline-flex items-center" :data-te-toggle="$attrs.title ? 'tooltip' : undefined">
        <label
            class="relative !flex items-center p-3 rounded-full"
          :class="!!$attrs.disabled ? 'cursor-auto opacity-50' : ''"
        >
          <input
            type="checkbox"
            class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-slate-300 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-0 checked:bg-default checked:before:bg-default hover:before:opacity-10"
            :class="{ 'before:hidden !cursor-auto': !!$attrs.disabled }"
            :checked = "$attrs.checked ?? !!modelValue"
            @change.prevent="onChangeValue"
            :disabled="!!$attrs.disabled"
            :id="id"
          />
          <div class="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3.5 w-3.5"
              viewBox="0 0 20 20"
              fill="currentColor"
              stroke="currentColor"
              stroke-width="1"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
        </label>
        <label v-if="label" class="text-sm font-medium text-gray-900 dark:text-gray-300">
            {{ label }}
        </label>
        <slot />
      </div>
</template>

<script>
import {initTE, Tooltip} from "tw-elements";

export default {
    name: 'Marker',
    props: {
        modelValue: Boolean,
        label: [String, Number],
        id: [String]
    },

    mounted () {
        initTE({ Tooltip }, { allowReinits: true })
    },

    methods: {
        onChangeValue (evt) {
            if (this.$attrs.disabled) return
            this.$emit('update:modelValue', evt.target.checked)
            this.$emit('change', evt.target.checked)
        }
    }

}
</script>

<style lang="scss" scoped>
@import './scss/marker.scss';
</style>
